import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

import { getToken } from "../../authConfig";
import { BlobUrlResponse, getBlobUrl } from "../../api"
import { handleError } from "../../toaster";
import { DocumentViewer } from "../../components/DocumentViewer";

const ViewDocument = () => {
    const client = useMsal().instance;
    const location = useLocation();
    const [blobUrl, setBlobUrl] = useState<string | undefined>(undefined);
    const [error, setError] = useState<string | undefined>(undefined);
    const queryParams = new URLSearchParams(location.search);

    // Extract documentName and pageNumber from the query string
    const documentName = queryParams.get("documentName") || "";
    const documentExt: any = documentName?.split(".").pop();
    const pageNumber = queryParams.get("pageNumber") || 1;

    async function fetchBlobUrl() {
        try {
            const token = client ? await getToken(client) : undefined;
            const response: BlobUrlResponse = await getBlobUrl(token, documentName)
            if (response.error) {
                setError(response.error);

            } else {
                setBlobUrl(response.url);
            }

        } catch (error) {
            setError("An unexpected error occurred while fetching the document.");
            handleError(error, "An unexpected error occurred while fetching the document.")
        }
    };

    useEffect(() => {
        fetchBlobUrl();
    }, [documentName]);

    return (
        <DocumentViewer
            blobUrl={blobUrl}
            documentExt={documentExt}
            pageNumber={pageNumber}
            error={error}
        />
    )
};

export default ViewDocument;